var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "noapp-nodoc-page" },
    [
      _c("header4IQ", { attrs: { fromapp: "ug", pagename: "noAppNoDoc" } }),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message" }, [
      _c("span", { staticClass: "title font-weight-black" }, [
        _vm._v("No Apps or Docs Configured, Please contact your Admin..")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }